import { create } from './deferred';
import type { Account } from '@patsnap-utils/biz';
import type Passport from '@patsnap-utils/passport/src/passport';

/**
 * 用户账号信息 Deferred
 */
export const accountDeferred = create<Account>('account');

/**
 * Passport 实例 Deferred（用于判断是否登录）
 */
export const prepareTokenDeferred = create<Passport>('prepareToken');

/**
 * 试用标志 Deferred
 */
export const addTrialDeferred = create<boolean>('addTrial');

/** 计划信息 Deferred
 * isFreemium: 是否为免费用户
 * isPersonal: 是否为个人用户
 */
export const planDeferred = create<{
    isFreemium: boolean;
    isPersonal: boolean;
}>('plan');
